import {Component, OnInit} from '@angular/core';
import {FormsModule, NgForm, ReactiveFormsModule} from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router, RouterLink} from "@angular/router";
import moment from "moment/moment";
import Swal from "sweetalert2";
import {of, switchMap} from "rxjs";

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit{

  constructor(
    public authService: AuthService,
    public router: Router
  ) {}

  ngOnInit() {
    const isAuth = this.authService.getIsAuth();
    const currentDate = moment().format('YYYY-MM-DD');

    if (isAuth) {
      this.router.navigate(['/calendario/' + currentDate]);
    }
  }

  onResetPassword(form: NgForm) {
    if(form.invalid) {
      Swal.fire({
        icon: 'error',
        title: 'Ops...',
        text: "Compila la mail per il reset della password",
        confirmButtonColor: '#050A30'
      });

      return;
    }
    //Chiamata al servizio per il reset della password
    this.authService.resetPassword(form.value.email)
      .pipe(
        switchMap((response) => {
          form.resetForm();

          Swal.fire({
            icon: 'success',
            title: 'Password aggiornata',
            text: 'Controlla la tua mail per il reset della password',
            timer: 3000
          });

          return of(response);
        })
    )
      .subscribe({
        error: (error) => {
          console.error("Errore nel reset della password", error);

          Swal.fire({
            icon: 'error',
            title: 'Ops...',
            text: error.error.message,
            confirmButtonColor: '#050A30'
          });
        }
      });

  }
}
